window.axios = require('axios');
import Vue from 'vue';

Vue.config.productionTip = false;

new Vue({
    components: {
    },
}).$mount('#app');


$('#closeNav').click(function() {
    $('#nav-mobile').hide();
});

$('#showNav').click(function() {
    $('#nav-mobile').show();
});

$('.nav-item').click(function() {
    $('#nav-mobile').hide();
});